import { render, staticRenderFns } from "./TreatmentsProfile.vue?vue&type=template&id=528b6d20"
import script from "./TreatmentsProfile.vue?vue&type=script&lang=js"
export * from "./TreatmentsProfile.vue?vue&type=script&lang=js"
import style0 from "./TreatmentsProfile.vue?vue&type=style&index=0&id=528b6d20&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports